export type AccessProfileScope = 'FeatureSet' | 'Role';

export interface AccessProfileDto {
  id: string;
  name: string;
  description: string;
  type: AccessProfileScope;
  isEnabled?: boolean;
  isEditable?: boolean;
  isDefault?: boolean;
  isDefaultAdminRole?: boolean;
  permissions: string[];
  fieldLevelPermissions?: string[];
  permissionChangeLogs?: AccessProfileChangeLog[] | null;
  linkedCount?: number;
  companyId?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface AccessProfileListItemDto {
  id: string;
  name: string;
  description: string;
  type: AccessProfileScope;
  isEnabled?: boolean;
  isEditable?: boolean;
  isDefault?: boolean;
  isDefaultAdminRole?: boolean;
  linkedCount?: number;
}

export interface AccessProfileChangeLog {
  id?: string;
  permission?: string | null;
  changeType?: string | null;
  changedByName?: string | null;
  changedAt?: string;
}

export interface AccessProfileListResponse {
  items: AccessProfileListItemDto[];
  totalCount: number;
}

export interface CreateAccessProfileDto {
  name: string;
  description: string;
  type: AccessProfileScope;
  isEnabled?: boolean;
  permissions: string[];
  fieldLevelPermissions?: string[];
}

export interface UpdateAccessProfileDto {
  id: string;
  name: string;
  description: string;
  type: AccessProfileScope;
  isEnabled?: boolean;
  permissions: string[];
  fieldLevelPermissions?: string[];
}

export interface DeleteAccessProfileResponseDto {
  success: boolean;
  message?: string;
  isAssigned?: boolean;
}

export interface AccessProfileQueryParams {
  filter?: string;
  selectedPermissions?: string[];
  sorting?: string;
  skipCount?: number;
  maxResultCount?: number;
}

export interface AccessProfilePageProps {
  scope: AccessProfileScope;
  hasId?: string;
}

export const ACCESS_PROFILE_CONFIG = {
  FeatureSet: {
    title: 'Feature Set',
    subtitle: 'Current list of Wealthlane system Feature Set.',
    nameField: 'name' as const,
    nameLabel: 'Name',
    addButtonLabel: 'Add Feature Set',
    entityLabel: 'Feature Set',
    permissionName: 'FeatureSet',
    permissionFeature: 'Vendor',
    queryKey: 'getAccessProfiles_FeatureSet',
    tableSchemaIdentifier: 'FEATURE_SET_TABLE',
    urlName: 'feature-set',
  },
  Role: {
    title: 'System Roles',
    subtitle: 'Current list of Wealthlane system access roles.',
    nameField: 'roleName' as const,
    nameLabel: 'Role Name',
    addButtonLabel: 'Add Role',
    entityLabel: 'System Role',
    permissionName: 'CustomerRoles',
    permissionFeature: 'Customer',
    queryKey: 'getAccessProfiles_Role',
    tableSchemaIdentifier: 'SYSTEMS_ROLES_TABLE',
    urlName: 'roles',
  },
} as const;
